// extracted by mini-css-extract-plugin
module.exports = {"arrow":"TopBar_arrow__2ffuv"};